<ion-menu contentId="main-content" type="overlay" [swipeGesture]="false">
  <ion-content [scrollY]="false" [scrollX]="false">
    <ion-list id="inbox-list">
      <ion-list-header>
        <div class="header-stack">
          <ion-label>IQ Connect {{version}}</ion-label>
        </div>
      </ion-list-header>
    </ion-list>
    <ion-list>
      @if (androidOsShortcuts.isAndroid) {
      <ion-item class="menu-item" (click)="openAndroidSystemSettings()">
        <ion-label>
          <h3>{{ 'main-menu-component.android-settings' | translate }}</h3>
        </ion-label>
        <ion-icon name="settings-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item class="menu-item" (click)="openAndroidGoogleProfile()">
        <ion-label>
          <h3>{{ 'main-menu-component.android-google-profile' | translate }}</h3>
        </ion-label>
        <ion-icon name="person-circle-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item class="menu-item" (click)="openAndroidNotifications()">
        <ion-label>
          <h3>{{ 'main-menu-component.android-notifications' | translate }}</h3>
        </ion-label>
        <ion-icon name="notifications-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item class="menu-item" (click)="openAndroidApps()">
        <ion-label>
          <h3>{{ 'main-menu-component.android-apps' | translate }}</h3>
        </ion-label>
        <ion-icon name="apps-outline" slot="end"></ion-icon>
      </ion-item>
      <ion-item class="menu-item" (click)="openAndroidBrowser()">
        <ion-label>
          <h3>{{ 'main-menu-component.android-browser' | translate }}</h3>
        </ion-label>
        <ion-icon name="globe-outline" slot="end"></ion-icon>
      </ion-item>
      }
      @if (enableDeviceEmulator) {
      <ion-item class="menu-item" (click)="showHideEmulator()">
        <ion-label>
          <h3>{{ 'main-menu-component.use-emulator' | translate }}</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
      }
      <ion-item class="menu-item" (click)="navigateToBleDebug()">
        <ion-label>
          <h3>BLE Debugging</h3>
        </ion-label>
        <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
      </ion-item>
    </ion-list>
    @if (enableDeviceEmulator && showEmulator) {
    <div>
      <app-iqconnect-emulator></app-iqconnect-emulator>
    </div>
    }
  </ion-content>
</ion-menu>